<template>
  <section class="section_store">
  <group :title="store.name" class="store_info">
    <cell>
      <span slot="icon" class="title">联系</span>
      <span slot="after-title">{{store.contact_name}}, {{store.contact_number}}</span>
      <a slot="value" :href="`tel:${store.contact_number}`">
        <img src="../../stylesheets/images/red-phone.png" class="icon_img">
      </a>
    </cell>
    <cell>
      <span slot="icon" class="title">地址</span>
      <span slot="after-title">{{store.address}}</span>
      <a slot="value" @click.stop="navigate()">
        <img src="../../stylesheets/images/red-address.png" class="icon_img">
      </a>
    </cell>
  </group>
  </section>
</template>
<script>
import {
  Group,
  Cell
} from '@lx-frontend/cvux'
export default {
  components: {
    Group,
    Cell
  },
  props: {
    store: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    navigate() {
      let address = this.store
      if (address) {
        this.$wechat.promise.then(wx => {
          wx.openLocationByWx(address.latitude || '', address.longitude || '', address.name || '', address.address || '', address.scale || 12, address.infoUrl || '')
        }, wx => {
          window.console.log('微信JSSDK校验错误:', JSON.stringfiy(wx.res))
        })
      }
    }
  }
}

</script>
<style lang="less">
@import '../../stylesheets/base/fn';
.section_store{
  background-color: #f0f0f0;
  padding-top: 20/@w2;
  margin-bottom: 20/@w2;
}
.store_info {
  background-color: #fff;
  .title {
    font-size: 30/@w2;
    padding-right: 50/@w2;
  }
  .weui_cells_title {
    opacity: 1;
    font-size: 30/@w2;
  }
  .weui_cells:before {
    left: 30/@w2;
  }
  .weui_cells:after {
    left: 30/@w2;
  }
  .icon_img {
    display: block;
    width: 36/@w2;
    height: 36/@w2;
  }
}

</style>
